import React from 'react';
import { Form, Input, Button, Card, Space, Layout, message } from 'antd';
import { useNavigate } from 'react-router';
import { userApi } from '../api/user';
import { LoginRequest } from '../api/user';
import { getPasswordHash } from '../util/crypto';

interface LoginFormValues {
  username: string;
  password: string;
}

const { Header, Content, Footer } = Layout;

const Login: React.FC = () => {
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: LoginFormValues) => {
    setLoading(true);
    try {
      const passwordHash = await getPasswordHash(values.password);
      const loginData: LoginRequest = {
        user_type: 'doctor',
        username: values.username,
        password_hash: passwordHash
      };
      const response = await userApi.login(loginData);
      if (response.success) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
        message.success('登录成功');
        navigate('/dashboard');
      } else {
        message.error(response.message || '登录失败，请检查用户名和密码');
      }
    } catch (error) {
      console.error('Login error:', error);
      message.error('网络错误，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
    message.error('表单验证失败，请检查输入');
  };

  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}>
      <Header style={{ background: '#fff', textAlign: 'center', padding: 0 }}>
        <h1>医生管理系统</h1>
      </Header>
      <Content style={{ padding: '0 50px' }}>
        <div style={{ 
          background: '#fff', 
          padding: 24, 
          marginTop: 24, 
          minHeight: 280, 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center' 
        }}>
          <Card title="医生登录" style={{ width: 300 }}>
            <Form<LoginFormValues>
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="用户名"
                name="username"
                rules={[{ required: true, message: '请输入您的用户名!' }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="密码"
                name="password"
                rules={[{ required: true, message: '请输入您的密码!' }]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Space>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    登录
                  </Button>
                  <Button type="link" onClick={() => navigate('/register')}>
                    注册账号
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </Content>
      <Footer style={{ textAlign: 'center' }}>医生管理系统 ©{new Date().getFullYear()}</Footer>
    </Layout>
  );
};

export default Login;